import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CrowdCountObservedStore, CrowdCountObservedState } from './crowd-count-observed.store';

@Injectable({ providedIn: 'root' })
export class CrowdCountObservedQuery extends QueryEntity<CrowdCountObservedState> {

  constructor(protected store: CrowdCountObservedStore) {
    super(store);
  }

}
